"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var UploadMedia_1 = __importDefault(require("@/Components/MediaLibrary/UploadMedia"));
var MediaPreviewModal_1 = __importDefault(require("@/Components/MediaLibrary/MediaPreviewModal"));
var doubleClick_1 = require("@/Hooks/doubleClick");
var react_i18next_1 = require("react-i18next");
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var List_1 = __importDefault(require("@mui/material/List"));
var ListItem_1 = __importDefault(require("@mui/material/ListItem"));
var ListItemAvatar_1 = __importDefault(require("@mui/material/ListItemAvatar"));
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var Checkbox_1 = __importDefault(require("@/Components/common/Checkbox"));
var GenericSnackbar_1 = __importDefault(require("../GenericSnackbar"));
var Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
var AppTemplateEditor_module_css_1 = __importDefault(require("./AppTemplateEditor.module.css"));
var ThumbnailWithSpinner_1 = __importDefault(require("./ThumbnailWithSpinner"));
var onlineResourceManager = new q_play_core_1.OnlineResourceManager();
var AppTemplateMediaTab = function (_a) {
    var appTemplateData = _a.appTemplateData;
    var t = (0, react_i18next_1.useTranslation)().t;
    var collectionName = "developer-app-template-".concat(appTemplateData.id, "-").concat(appTemplateData.current_version);
    var dataProvider = (0, AjaxProvider_1.default)("/api");
    var logger = q_play_core_1.logManager.getLogger();
    var _b = (0, react_1.useState)([]), mediaItems = _b[0], setMediaItems = _b[1];
    var _c = (0, react_1.useState)(false), hasFetched = _c[0], setHasFetched = _c[1];
    var _d = (0, react_1.useState)(false), isPreviewOpen = _d[0], setIsPreviewOpen = _d[1];
    var _e = (0, react_1.useState)(""), previewUrl = _e[0], setPreviewUrl = _e[1];
    var _f = (0, react_1.useState)(""), previewMediaType = _f[0], setPreviewMediaType = _f[1];
    var _g = (0, react_1.useState)(new Set()), selectedItems = _g[0], setSelectedItems = _g[1];
    var _h = (0, react_1.useState)(false), selectAll = _h[0], setSelectAll = _h[1];
    var _j = (0, react_1.useState)(new Set()), deletingItems = _j[0], setDeletingItems = _j[1];
    var _k = (0, react_1.useState)(false), isDeletingSelected = _k[0], setIsDeletingSelected = _k[1];
    var _l = (0, react_1.useState)(false), snackbarOpen = _l[0], setSnackbarOpen = _l[1];
    var _m = (0, react_1.useState)(""), snackbarMessage = _m[0], setSnackbarMessage = _m[1];
    var _o = (0, react_1.useState)("success"), snackbarSeverity = _o[0], setSnackbarSeverity = _o[1];
    var fetchTemplateMedia = (0, react_1.useCallback)(function (forceFetch) {
        if (forceFetch === void 0) { forceFetch = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var endpoint, response, media, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (hasFetched && !forceFetch)
                            return [2 /*return*/];
                        endpoint = "developer-media/template/".concat(appTemplateData.id, "/").concat(appTemplateData.current_version);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dataProvider.get(endpoint)];
                    case 2:
                        response = _b.sent();
                        media = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.media) || [];
                        setMediaItems(media);
                        setHasFetched(true);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        logger.error("Failed to fetch template media for template ID ".concat(appTemplateData.id, ", version ").concat(appTemplateData.current_version, " from endpoint \"").concat(endpoint, "\"."), error_1);
                        setMediaItems([]);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }, [appTemplateData.id, appTemplateData.current_version, dataProvider, hasFetched, logger]);
    (0, react_1.useEffect)(function () {
        if (!hasFetched) {
            fetchTemplateMedia();
        }
    }, [fetchTemplateMedia, hasFetched]);
    var handleDeleteMedia = function (uuids, isBulkDelete) {
        if (isBulkDelete === void 0) { isBulkDelete = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setSnackbarMessage(t("Deleting media..."));
                        setSnackbarSeverity("info");
                        setSnackbarOpen(true);
                        if (isBulkDelete) {
                            setIsDeletingSelected(true);
                        }
                        else {
                            setDeletingItems(function (prev) {
                                var newSet = new Set();
                                prev.forEach(function (value) { return newSet.add(value); });
                                Array.from(uuids).forEach(function (uuid) { return newSet.add(uuid); });
                                return newSet;
                            });
                        }
                        return [4 /*yield*/, Promise.all(Array.from(uuids).map(function (uuid) { return __awaiter(void 0, void 0, void 0, function () {
                                var endpoint, request;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            endpoint = "/api/developer-media/template/".concat(appTemplateData.id, "/").concat(appTemplateData.current_version, "/").concat(uuid);
                                            request = onlineResourceManager.makeJSONRequest(endpoint, "DELETE");
                                            return [4 /*yield*/, request.getResponseRaw()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        setMediaItems(function (prev) { return prev.filter(function (item) { return !Array.from(uuids).includes(item.uuid); }); });
                        setSelectedItems(function (prev) {
                            var newSet = new Set();
                            prev.forEach(function (uuid) { return newSet.add(uuid); });
                            Array.from(uuids).forEach(function (uuid) { return newSet.delete(uuid); });
                            return newSet;
                        });
                        setSelectAll(false);
                        setSnackbarMessage(t("Media deleted successfully."));
                        setSnackbarSeverity("success");
                        setSnackbarOpen(true);
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        logger.error("Failed to delete media", error_2);
                        setSnackbarMessage(t("Failed to delete media."));
                        setSnackbarSeverity("error");
                        setSnackbarOpen(true);
                        return [3 /*break*/, 4];
                    case 3:
                        if (isBulkDelete) {
                            setIsDeletingSelected(false);
                        }
                        else {
                            setDeletingItems(function (prev) {
                                var newSet = new Set();
                                prev.forEach(function (uuid) { return newSet.add(uuid); });
                                Array.from(uuids).forEach(function (uuid) { return newSet.delete(uuid); });
                                return newSet;
                            });
                        }
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var handleItemSelection = function (uuid) {
        setSelectedItems(function (prev) {
            var newSet = new Set(prev);
            if (newSet.has(uuid)) {
                newSet.delete(uuid);
            }
            else {
                newSet.add(uuid);
            }
            return newSet;
        });
    };
    var handleSelectAll = function () {
        setSelectAll(function (prev) { return !prev; });
        if (!selectAll) {
            setSelectedItems(new Set(mediaItems.map(function (item) { return item.uuid; })));
        }
        else {
            setSelectedItems(new Set());
        }
    };
    var openMediaPreview = function (url, mediaType) {
        setPreviewUrl(url);
        setPreviewMediaType(mediaType);
        setIsPreviewOpen(true);
    };
    return (react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["media-container"] },
        react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["media-actions"] },
            react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["select-all-checkbox"] },
                react_1.default.createElement(Checkbox_1.default, { checked: selectAll, onChange: handleSelectAll }),
                react_1.default.createElement(IconButton_1.default, { onClick: function () { return handleDeleteMedia(Array.from(selectedItems), true); }, disabled: selectedItems.size === 0 || isDeletingSelected, sx: {
                        marginLeft: "14px",
                        color: "var(--error-color)",
                        transition: "opacity 0.3s",
                        opacity: selectedItems.size === 0 || isDeletingSelected ? 0.5 : 1,
                        "&:hover": {
                            opacity: 0.7
                        }
                    } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashList, style: { width: "25px" } })))),
        react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["media-list-container"] }, mediaItems.length > 0 ? (react_1.default.createElement(List_1.default, null, mediaItems.map(function (item) {
            var handleItemClick = (0, doubleClick_1.createDoubleClickPreviewHandler)(function () { return handleItemSelection(item.uuid); }, function () { return openMediaPreview(item.url, item.mediaType || "image"); });
            var isSelected = selectedItems.has(item.uuid);
            var isDeleting = deletingItems.has(item.uuid);
            return (react_1.default.createElement(ListItem_1.default, { key: item.uuid, className: AppTemplateEditor_module_css_1.default["media-list-item"], onClick: handleItemClick, sx: {
                    backgroundColor: isSelected ? "var(--secondary-color)" : "#f1f0ef90",
                    borderRadius: "8px",
                    marginBottom: "8px",
                    padding: "10px",
                    transition: "background-color 0.2s",
                    "&:hover": {
                        backgroundColor: "#e0dfde",
                        cursor: "pointer"
                    }
                }, secondaryAction: react_1.default.createElement(IconButton_1.default, { edge: "end", "aria-label": "delete", onClick: function (e) {
                        e.stopPropagation();
                        handleDeleteMedia([item.uuid]);
                    }, disabled: isDeleting || isDeletingSelected },
                    react_1.default.createElement(Delete_1.default, { color: isDeleting ? "disabled" : "error" })) },
                react_1.default.createElement("div", { onClick: function (e) { return e.stopPropagation(); } },
                    react_1.default.createElement(Checkbox_1.default, { checked: isSelected, onChange: function () { return handleItemSelection(item.uuid); }, style: { marginRight: "10px" } })),
                react_1.default.createElement(ListItemAvatar_1.default, null,
                    react_1.default.createElement(ThumbnailWithSpinner_1.default, { src: item.thumbnailUrl || item.url, alt: item.name })),
                react_1.default.createElement(ListItemText_1.default, { primary: item.name, secondary: "type: ".concat(item.mediaType || "N/A"), style: { color: "var(--info-color)" } })));
        }))) : (react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["no-media-container"] },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faFileSlash, className: AppTemplateEditor_module_css_1.default["no-media-icon"] }),
            react_1.default.createElement("p", { className: AppTemplateEditor_module_css_1.default["no-media-text"] }, t("No media available."))))),
        react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["upload-button-container"] },
            react_1.default.createElement(UploadMedia_1.default, { collectionName: collectionName, editorType: "template", id: appTemplateData.id, version: appTemplateData.current_version, t: t, updateFiles: function () { return fetchTemplateMedia(true); }, style: { width: "100%" } })),
        react_1.default.createElement(MediaPreviewModal_1.default, { isShown: isPreviewOpen, toggle: function () { return setIsPreviewOpen(false); }, url: previewUrl, mediaType: previewMediaType }),
        react_1.default.createElement(GenericSnackbar_1.default, { open: snackbarOpen, onClose: function () { return setSnackbarOpen(false); }, message: snackbarMessage, severity: snackbarSeverity, snackbarStyle: { marginTop: "150px" } })));
};
exports.default = AppTemplateMediaTab;
